import { render, staticRenderFns } from "./CompareView.vue?vue&type=template&id=5e455a39&"
import script from "./CompareView.vue?vue&type=script&lang=js&"
export * from "./CompareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports